// extracted by mini-css-extract-plugin
export default {"base":"vp_ob4eG","silent":"vp_vA1Ol","bkg":"vp_kfZZw","outline":"vp_A9dhq"};